<template>
    <div>
        <b-card no-body class="mb-0">

            <div class="m-2">
                <b-row>

                    <!-- Per Page -->
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                        <label>Mostrar</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>registros</label>
                    </b-col>

                    <!-- Search + Nuevo -->
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Buscar por alias, dirección o distrito ..."
                            />
                            <b-button
                                variant="primary"
                                :to="{ name: 'warehouse-create' }"
                            >
                                <span class="text-nowrap">NUEVO ALMACÉN</span>
                            </b-button>
                        </div>
                    </b-col>

                </b-row>
            </div>

            <b-table
                ref="refWarehouseListTable"
                class="position-relative"
                :style="totalWarehouses < 3 && totalWarehouses > 0 ? 'height: 250px' : 'height: inherit'"
                :items="fetchWarehouses"
                responsive
                :fields="tableColumns"
                primary-key="_id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No se encontraron registros coincidentes"
                :sort-desc.sync="isSortDirDesc"
            >

                <!-- Alias -->
                <template #cell(alias)="data">
                    <div class="font-weight-bolder">{{ data.item.alias }}</div>
                    <b-badge
                        v-if="data.item.is_default"
                        variant="light-primary"
                        class="mt-25"
                    >
                        POR DEFECTO
                    </b-badge>
                </template>

                <!-- Orden de búsqueda de stock -->
                <template #cell(priority)="data">
                    <div class="d-flex align-items-center">
                        <span class="font-weight-bolder mr-50">{{ data.item.priority }}</span>
                        <b-button
                            variant="flat-secondary"
                            class="btn-icon"
                            size="sm"
                            title="Subir"
                            :disabled="reordering || data.item.priority <= 1"
                            @click="moveWarehouse(data.item, -1)"
                        >
                            <feather-icon icon="ChevronUpIcon" size="14" />
                        </b-button>
                        <b-button
                            variant="flat-secondary"
                            class="btn-icon"
                            size="sm"
                            title="Bajar"
                            :disabled="reordering"
                            @click="moveWarehouse(data.item, 1)"
                        >
                            <feather-icon icon="ChevronDownIcon" size="14" />
                        </b-button>
                    </div>
                </template>

                <!-- Dirección -->
                <template #cell(address)="data">
                    <div>{{ data.item.address }}</div>
                    <small class="text-muted">{{ data.item.schedule || '---' }}</small>
                </template>

                <!-- Teléfono -->
                <template #cell(phone)="data">
                    {{ data.item.phone || '---' }}
                </template>

                <!-- Recojo -->
                <template #cell(allows_pickup)="data">
                    <b-badge :variant="data.item.allows_pickup ? 'light-success' : 'light-secondary'">
                        {{ data.item.allows_pickup ? 'SÍ' : 'NO' }}
                    </b-badge>
                </template>

                <!-- Estado -->
                <template #cell(is_active)="data">
                    <b-badge :variant="data.item.is_active ? 'light-success' : 'light-danger'">
                        {{ data.item.is_active ? 'ACTIVO' : 'INACTIVO' }}
                    </b-badge>
                </template>

                <!-- Acciones -->
                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                    >

                        <template #button-content>
                            <feather-icon
                                icon="MoreVerticalIcon"
                                size="16"
                                class="align-middle text-body"
                            />
                        </template>

                        <b-dropdown-item :to="{ name: 'warehouse-edit', params: { id: data.item._id } }">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Editar</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="changeStateWarehouse(data.item._id, true)" v-if="!data.item.is_active">
                            <feather-icon icon="CheckCircleIcon" />
                            <span class="align-middle ml-50">Habilitar</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="changeStateWarehouse(data.item._id, false)" v-else>
                            <feather-icon icon="SlashIcon" />
                            <span class="align-middle ml-50">Deshabilitar</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteWarehouse(data.item._id)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Eliminar</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

            </b-table>

            <div class="mx-2 mb-2">
                <b-row>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalWarehouses"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </b-col>

                </b-row>
            </div>

        </b-card>
    </div>
</template>

<script>

    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BBadge,
        BDropdown, BDropdownItem, BPagination
    } from 'bootstrap-vue';
    import { ref, onUnmounted } from '@vue/composition-api';
    import { useToast } from 'vue-toastification/composition';
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import vSelect from 'vue-select';
    import store from '@/store';
    import Vue from 'vue';

    import warehouseStoreModule from '../warehouseStoreModule';
    import useWarehousesList from './useWarehousesList';

    export default {
        components: {
            BCard,
            BRow,
            BCol,
            BFormInput,
            BButton,
            BTable,
            BBadge,
            BDropdown,
            BDropdownItem,
            BPagination,

            vSelect
        },
        setup() {

            // Use toast
            const toast = useToast();

            const WAREHOUSE_APP_STORE_MODULE_NAME = 'app-warehouse';

            // Register module
            if (!store.hasModule(WAREHOUSE_APP_STORE_MODULE_NAME)) store.registerModule(WAREHOUSE_APP_STORE_MODULE_NAME, warehouseStoreModule);

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(WAREHOUSE_APP_STORE_MODULE_NAME)) store.unregisterModule(WAREHOUSE_APP_STORE_MODULE_NAME);
            });

            const {
                fetchWarehouses,
                tableColumns,
                perPage,
                currentPage,
                totalWarehouses,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refWarehouseListTable,
                refetchData,

                statesFilter
            } = useWarehousesList();

            const reordering = ref(false);

            /* El backend renumera 1..N, asi que necesita la lista completa y no
               solo la pagina visible. */
            const moveWarehouse = async (warehouse, offset) => {
                reordering.value = true;

                try {
                    const { data } = await store.dispatch('app-warehouse/fetchWarehouses', {
                        q: '',
                        perPage: 1000,
                        page: 1,
                        sortBy: 'priority',
                        sortDesc: false
                    });

                    const ids = data.warehouses.map(item => item._id);
                    const from = ids.indexOf(warehouse._id);
                    const to = from + offset;

                    if (from < 0 || to < 0 || to >= ids.length) return;

                    ids.splice(to, 0, ids.splice(from, 1)[0]);

                    const response = await store.dispatch('app-warehouse/reorderWarehouses', { ids });

                    refetchData();
                    notifySuccess(response.data.message);
                } catch (err) {
                    notifyError(err, 'Error al reordenar los almacenes');
                } finally {
                    reordering.value = false;
                }
            };

            const notifyError = (err, fallback) => {
                const message = err && err.response && err.response.data.message ?
                    err.response.data.message : fallback;

                toast({
                    component: ToastificationContent,
                    props: {
                        title: message,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            };

            const notifySuccess = (message) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: message,
                        icon: 'CheckIcon',
                        variant: 'success'
                    }
                });
            };

            const changeStateWarehouse = (id, is_active) => {
                store.dispatch('app-warehouse/changeStateWarehouse', { id, is_active })
                    .then(response => {
                        refetchData();
                        notifySuccess(response.data.message);
                    })
                    .catch(err => notifyError(err, 'Error al cambiar el estado del almacén'));
            };

            const deleteWarehouse = (id) => {
                Vue.swal({
                    title: '¿Estás seguro de eliminar el almacén?',
                    text: "¡Si no lo está, puede cancelar la acción!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, eliminar!',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    showClass: {
                        popup: 'animate__animated animate__tada'
                    },
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        store.dispatch('app-warehouse/deleteWarehouse', { id })
                            .then(response => {
                                refetchData();
                                notifySuccess(response.data.message);
                            })
                            .catch(err => notifyError(err, 'Error al eliminar el almacén'));
                    }
                });
            };

            return {
                fetchWarehouses,
                tableColumns,
                perPage,
                currentPage,
                totalWarehouses,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refWarehouseListTable,
                refetchData,

                statesFilter,

                changeStateWarehouse,
                deleteWarehouse,

                reordering,
                moveWarehouse
            }
        }
    }

</script>

<style lang="scss" scoped>
    .per-page-selector { width: 90px; }
</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
